import React from 'react';
import classNames from 'classnames';

import s from './styles.module.scss';

interface IProps {
  color: string;
  name: string;
  width?: string;
  height?: string;
  shape?: 'square' | 'triangle';
}

export const ChartsLegendItem: React.FC<IProps> = ({
  color,
  name,
  width = '16px',
  height = '16px',
  shape = 'square',
}) => {
  return (
    <div className={s.wrapper}>
      <span
        className={classNames(s.color, { [s.triangle]: shape === 'triangle' })}
        style={{ background: color, width, height }}
      />
      {name}
    </div>
  );
};
